import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {ModelManager, Constants} from '@adobe/aem-spa-page-model-manager';
import {store} from '@/store';
import App from './App';
import {filterCqItemsByType} from '@/utils/aem-utils';
import './MappedComponents';
import {AEM_MAPPED_TYPES} from '@/constants';
import NotificationContainer from '@/features/notifications/components/NotificationsContainer';

const SELECTOR = '.product-pricing-modal-root';

const appWrapper = document.querySelector(SELECTOR);

if (appWrapper) {
  const root = createRoot(appWrapper);

  function render(model) {
    const {filteredItems, filteredItemsOrder} = filterCqItemsByType(
      model[Constants.ITEMS_PROP],
      model[Constants.ITEMS_ORDER_PROP],
      AEM_MAPPED_TYPES.PRODUCT_PRICING_MODAL,
    );
    root.render(
      <Provider store={store}>
        <App
          cqChildren={model[Constants.CHILDREN_PROP]}
          cqItems={filteredItems}
          cqItemsOrder={filteredItemsOrder}
          cqPath={model[Constants.PATH_PROP]}
          appWrapper={appWrapper}
        />
        <NotificationContainer />
      </Provider>,
    );
  }

  ModelManager.initialize({path: process.env.REACT_APP_PAGE_MODEL_PATH}).then(render);
}
